export default __webpack_public_path__ + "static/media/preloaderSpinnerAnimation.0dc76c50.svg";